<div class="pRntMn flex-container">
  <div class="flex-item-left" [ngClass]="!showLoginBlock ? 'lFpne' : 'lFpne2'">
    <div *ngIf="!showLoginBlock" style="height: 90%;" class="col-xs-12">
      <div class="TstMnls" style="min-height: 68%;">
        <span class="qoute-style">
          <img src="../../assets/images/registration/quotes_text_icon.svg" width="30" />
        </span>
        <div class="CstmrLg">
          <span class="lf">
            <img src="{{carousel[counter].logo_url}}" height="50" />
          </span>
        </div>
        <div class="cmNtsTx">
          <div class="Cmnts">
            <p>
              {{carousel[counter].tstmnl}}
            </p>
          </div>
          <div class="cLntDtls">
            <span style="float: left; margin-left: -4px">
              <img src="{{carousel[counter].image_url}}" width="62" />
            </span>
            <span style="float: left; padding-top: 10px; padding-left: 6px">
              <label style="font-size: 0.92rem; font-family: HKGroteskBold">{{carousel[counter].name}}</label>
              <p style="font-size: 0.82rem; font-family: HKGroteskRegular">
                {{carousel[counter].designation}}
              </p>
            </span>
          </div>
        </div>
        <div class="pagntn">
          <span>
            <div *ngIf="counter==0; then lf_gry else lf_blue">
              Here is never showing
            </div>
            <ng-template #lf_gry>
              <img src="../../assets/images/registration/lf_arw.svg" style="cursor: pointer;padding-top: 1px;"
                (click)="changeSlidePrev()" width="13" />
            </ng-template>
            <ng-template #lf_blue>
              <img src="../../assets/images/registration/lf_arw_bl.svg" style="cursor: pointer;padding-top: 1px;"
                (click)="changeSlidePrev()" width="13" />
            </ng-template>
          </span>
          <label>
            {{counter+1}}/{{carousel.length}}
          </label>
          <span>
            <div *ngIf="counter==carousel.length-1; then rt_gry else rt_blue">
              Here is never showing
            </div>
            <ng-template #rt_gry>
              <img src="../../assets/images/registration/rt_arw_grey.svg" style="cursor: pointer;padding-top: 1px;"
                (click)="changeSlidePrev()" width="13" />
            </ng-template>
            <ng-template #rt_blue>
              <img src="../../assets/images/registration/rt_arw.svg" style="cursor: pointer;padding-top: 1px;"
                (click)="changeSlideNext()" width="13" />
            </ng-template>
          </span>
        </div>
      </div>
      <div class="info_style">
        <div class="cntct">
          <p class="info-p" style="margin: 10px; color: #48546a">
            Need more information?
          </p>
          <a href="https://sarasanalytics.com/contact/">
            <button _ngcontent-oiv-c6="" class="btn-block mat-stroked-button mat-button-base mat-primary"
              color="primary" mat-stroked-button="">
              <span class="mat-button-wrapper">Connect with our Data experts</span>
              <div class="mat-button-ripple mat-ripple" matripple=""></div>
              <div class="mat-button-focus-overlay"></div>
            </button></a>
        </div>
        <div class="ctmLg">
          <div class="hd">
            <span class="span"> Trusted by &nbsp; </span>
          </div>
          <div class="marquee-wrapper-signup">
            <div class="img-container-signup">
              <div class="marquee-block-signup">
                <div class="marquee-inner to-left">
                  <span>
                    <ng-template [ngTemplateOutlet]="ImgRef_signUp1"></ng-template>
                  </span>
                  <span>
                    <ng-template [ngTemplateOutlet]="ImgRef_signUp2"></ng-template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="(!showForgotPassword && showLoginBlock) || (showForgotPassword && showLoginBlock)"
      style="background: url(dot_rt.svg) no-repeat left 24px;">
      <div style="padding-top: 40%;">
        <div class="marquee-wrapper">
          <div class="img-container">
            <div class="marquee-block">
              <div class="marquee-inner to-left">
                <span>
                  <ng-template [ngTemplateOutlet]="ImgRef_row1"></ng-template>
                </span>
                <span>
                  <ng-template [ngTemplateOutlet]="ImgRef_row1"></ng-template>
                </span>
              </div>
            </div>
            <div class="marquee-block">
              <div class="marquee-inner to-right">
                <span>
                  <ng-template [ngTemplateOutlet]="ImgRef_row2"></ng-template>
                </span>
                <span>
                  <ng-template [ngTemplateOutlet]="ImgRef_row2"></ng-template>
                </span>
              </div>
            </div>
            <div class="marquee-block">
              <div class="marquee-inner to-left">
                <span>
                  <ng-template [ngTemplateOutlet]="ImgRef_row3"></ng-template>
                </span>
                <span>
                  <ng-template [ngTemplateOutlet]="ImgRef_row3"></ng-template>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="cntct login-style">
          <div style="text-align: center;">
            <h3 _ngcontent-oiv-c1="" class="mb-1 h3">
              Helping to lay the foundation for a
              <div style="text-align: center;"><span class="span"> data-led business</span></div>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="rTpne flex-item-right ">
    <div style="background: white; width: 64%;
    padding-left: 5%;" class="mobile-view">
      <div *ngIf="!showLoginBlock">
        <div _ngcontent-oiv-c1="" class="card-body">
          <div _ngcontent-oiv-c1="" class="row justify-content-between align-items-center pd_b">
            <div _ngcontent-oiv-c1="" class="col-auto">
              <span _ngcontent-oiv-c1="" class="daton-logo mb-3"></span>
            </div>
          </div>
          <h3 _ngcontent-oiv-c1="" class="mb-1 h3">
            Get Started with your
            <span class="span"> 14-day free trial!</span>
          </h3>
          <div _ngcontent-oiv-c1="" class="mb-3">
            <span _ngcontent-oiv-c1="" class="ftur_labels">Easy Setup</span>

            <span _ngcontent-oiv-c1="" class="ftur_labels" style="color: #e1e1e1">|</span>

            <span _ngcontent-oiv-c1="" class="ftur_labels">Enterprise Security</span>

            <span _ngcontent-oiv-c1="" class="ftur_labels" style="color: #e1e1e1">|</span>

            <span _ngcontent-oiv-c1="" class="ftur_labels">No Code Pipeline</span>

            <span _ngcontent-oiv-c1="" class="ftur_labels" style="color: #e1e1e1">|</span>

            <span _ngcontent-oiv-c1="" class="ftur_labels">Auto Updates</span>
          </div>
          <form _ngcontent-oiv-c1="" novalidate="" name="daton-signup-form" class="daton-signup-form ng-untouched ng-pristine ng-valid" #signUpForm="ngForm">
            <div _ngcontent-oiv-c1="" class="row">
              <div _ngcontent-oiv-c1="" class="col col_rg">
                <mat-form-field style="font-size: 14.2px" appearance="fill">
                  <mat-label>First name</mat-label>
                  <input matInput type="text" name="firstname" #firstname="ngModel"
                    [(ngModel)]="userSignUpInfo.firstName" pattern="^[a-zA-Z]+$" [maxlength]="49" required>
                </mat-form-field>
                <div class="touched-error text-error">
                  <div *ngIf="firstname.touched && !firstname.valid">
                    First name can have only alphabets. (numbers, spaces, special characters) not allowed.
                  </div>
                </div>
              </div>
              <div _ngcontent-oiv-c1="" class="col col_rg">
                <mat-form-field style="font-size: 14.2px" appearance="fill">
                  <mat-label>Last name</mat-label>
                  <input matInput type="text" name="lastname" #lastname="ngModel" [(ngModel)]="userSignUpInfo.lastName"
                    pattern="^[a-zA-Z]+$" [maxlength]="49" required>
                </mat-form-field>

                <div class="touched-error text-error">
                  <div *ngIf="lastname.touched && !lastname.valid">
                    Last name can have only alphabets. (numbers, spaces, special characters) not allowed.
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-oiv-c1="" class="row">
              <div _ngcontent-oiv-c1="" class="col col_rg">

                <mat-form-field style="font-size: 14.2px" appearance="fill">
                  <mat-label>Email address</mat-label>
                  <input matInput type="email" name="email" #email="ngModel" [(ngModel)]="userSignUpInfo.email"
                    [maxlength]="49" email required>
                </mat-form-field>
                <div class="touched-error text-error">
                  <div *ngIf="(email.touched && !email.valid) || (email.touched && !hasTLD(email))">
                    Email address is not valid.
                  </div>
                  <div *ngIf="email.touched && email.valid && !checkEmail(email)">
                    We do not accept {{currentDomain}} for email ids 
                    Please enter business email : {{exampleBusinessEmail}}
                  </div>
                </div>
              </div>
              <div _ngcontent-oiv-c1="" class="col col_rg">
                <mat-form-field style="font-size: 14.2px" appearance="fill">
                  <mat-label>Company name</mat-label>
                  <input matInput type="text" name="companyname" #company="ngModel"  [(ngModel)]="userSignUpInfo.company.name"
                    [maxlength]="100" required>
                </mat-form-field>
                <div class="touched-error text-error">
                  <div *ngIf="company.touched && !company.valid">
                    Company name cannot be empty.
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-oiv-c1="" class="row">
              <div _ngcontent-oiv-c1="" class="col-6 col_rg">
                <mat-form-field style="font-size: 14.2px" appearance="fill">
                  <mat-label>Password</mat-label>
                  <div class="inner-addon right-addon">

                    <input matInput type='password' id="inputPassword" [type]="fieldTextType_P ? 'text' : 'password'"
                      (keyup)="onKey($event)" name="password" #password="ngModel" [(ngModel)]="userSignUpInfo.password"
                      [minlength]="6" [maxlength]="15"
                      required>
                    <div>
                      <i alt="show" class="far fa-eye-slash eye-hide" (click)="fieldTextType_P = !fieldTextType_P"
                        [class.hide]="fieldTextType_P"></i>
                      <i alt="hide" class="far fa-eye eye-show " (click)="fieldTextType_P = !fieldTextType_P"
                        [class.hide]="!fieldTextType_P"></i>
                    </div>
                  </div>
                </mat-form-field>
                <div class="touched-error text-error">
                  <div *ngIf="(password.touched && !password.valid)">
                    Password should have 6 to 15 characters.
                  </div>
                </div>
              </div>
              <div _ngcontent-oiv-c1="" class="col-6 col_rg">
                <mat-form-field style="font-size: 14.2px" appearance="fill">
                  <mat-label>Confirm password</mat-label>
                  <div class="inner-addon right-addon">

                    <input matInput type='password' id="inputPassword" [type]="fieldTextType_CP ? 'text' : 'password'"
                      name="verifypassword" #verifypassword="ngModel" [(ngModel)]="verifyPassword" [minlength]="6" [maxlength]="15"
                      required>
                    <div>
                      <i alt="show" class="far fa-eye-slash eye-hide" (click)="fieldTextType_CP = !fieldTextType_CP"
                        [class.hide]="fieldTextType_CP"></i>
                      <i alt="hide" class="far fa-eye eye-show" (click)="fieldTextType_CP = !fieldTextType_CP"
                        [class.hide]="!fieldTextType_CP"></i>
                    </div>
                  </div>
                </mat-form-field>
                <div class="touched-error text-error">
                  <div *ngIf="(verifypassword.touched && !verifypassword.valid)">
                    Confirm password should have 6 to 15 characters.
                  </div>
                  <div
                    *ngIf="!((verifypassword.touched && !verifypassword.valid) || (password.touched && !password.valid)) && userSignUpInfo.password !== verifyPassword && verifypassword.touched && password.touched">
                    Password and Confirm password do not match.
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div *ngIf="(text_value!='hide')" class="col-6">
                <div
                  class="password-management {{(strong_password === (true) )? 'strong':(medium_password === (true))?'medium':(weak_password ===(true))?'week':''}} ">
                  <strong>{{text_value}}</strong>
                  <span></span>
                </div>
              </div>
            </div>

            <div _ngcontent-oiv-c1="" class="d-flex mt-1 mb-4 terms_policy w-100" style="word-spacing: 2px;">
              <span><input type="checkbox" name="consent_status" [(ngModel)]="consent_status" (click)="updateConsentStatus(consent_status)" required></span>
              <span _ngcontent-oiv-c1="" class="label-07">By Clicking on “Create Account”, you agree to Daton
                <a _ngcontent-oiv-c1="" class="HKGroteskBold" href=" https://sarasanalytics.com/terms-of-use/"
                  target="_blank">Terms, </a>
                <a _ngcontent-oiv-c1="" class="HKGroteskBold" href="https://sarasanalytics.com/privacy/"
                  target="_blank">Privacy Policy</a> and consent to our use of cookies.</span>
            </div>

            <button mat-flat-button color="orange" style="cursor:pointer" class="btn-block btn-lg" type="submit"
              (click)="signUp(signUpForm)"
              [disabled]="!signUpForm.form.valid || userSignUpInfo.password!==verifyPassword || invalidEmailCompany || !TLD">
              <span class="mat-button-wrapper" *ngIf="!under_creating_account">
                Create Account
                <span class="button-right-arrow arrow-style"></span>
              </span>
              <span class="loading-dots" *ngIf="under_creating_account">Creating account</span>
            </button>
          </form>
          <div _ngcontent-axv-c12="" class="mt-4 text-center">
            <span _ngcontent-axv-c12="" class="label-07">Already have an account?
              <a _ngcontent-axv-c12="" class="HKGroteskBold" (click)="toggleSignIn()">Login</a></span>
          </div>
        </div>
      </div>
      <div *ngIf="(!showForgotPassword && showLoginBlock)" class="mobile-view2" style="width: 80%;padding-left: 12%;">
        <div _ngcontent-oiv-c1="" class="card-body" >
          <div _ngcontent-oiv-c1="" class="row justify-content-between align-items-center pd_b">
            <div _ngcontent-oiv-c1="" class="col-auto">
              <span _ngcontent-oiv-c1="" class="daton-logo mb-3"></span>
            </div>
          </div>
          <h3 _ngcontent-oiv-c1="" class="mb-1 h3">
            Welcome Back!
          </h3>
          <div _ngcontent-oiv-c1="" class="mb-3">
            <span _ngcontent-oiv-c1="" class="ftur_labels">Log in to your account.</span>
          </div>
          <form #signInForm="ngForm" name="daton-login-form" class="daton-login-form">
            <div _ngcontent-oiv-c1="" class="row">
              <div _ngcontent-oiv-c1="" class="col col_rg">
                <!-- <div class="form-group mb-3"> -->
                  <mat-form-field style="font-size: 14.2px" appearance="fill">
                    <mat-label>Email address</mat-label>
                    <input matInput type="email" name="email" #email="ngModel" [(ngModel)]="userSignInInfo.email" email
                      required>
                  </mat-form-field>
                  <div class="touched-error text-error">
                    <div *ngIf="email.touched && !email.valid">
                      Not a valid email.
                    </div>
                  </div>
                  <div class="touched-error text-error">
                    <span *ngIf="
                        email.touched && userSignInInfo?.email?.length == 0
                      ">
                      Enter email.
                    </span>
                  </div>
                <!-- </div> -->
              </div>
            </div>
            <div _ngcontent-oiv-c1="" class="row">
              <div _ngcontent-oiv-c1="" class="col col_rg">
                <!-- <div class="form-group mb-4"> -->

                  <mat-form-field style="font-size: 14.2px" appearance="fill">
                    <mat-label>Password</mat-label>
                    <div class="inner-addon right-addon">

                      <input matInput type='password' id="inputPassword" [type]="fieldTextType_P ? 'text' : 'password'"
                        name="password" #password="ngModel" [(ngModel)]="userSignInInfo.password" [minlength]="6" required>
                      <div>
                        <i alt="show" class="far fa-eye-slash eye-hide" (click)="fieldTextType_P = !fieldTextType_P"
                          [class.hide]="fieldTextType_P"></i>
                        <i alt="hide" class="far fa-eye eye-show" (click)="fieldTextType_P = !fieldTextType_P"
                          [class.hide]="!fieldTextType_P"></i>
                      </div>
                    </div>
                  </mat-form-field>
                  <div class="touched-error text-error">
                    <div *ngIf="(password.touched && !password.valid)">
                      Password should have 6 to 15 characters.
                    </div>
                  </div>
                <!-- </div> -->


              </div>
            </div>

            <div class="row mb-5 justify-content-between">
              <div class="col-auto">
                <label class="label-checkbox keeplogged">Remember me
                  <input type="checkbox" [(ngModel)]="rememberMe" [ngModelOptions]="{ standalone: true }" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="col-auto">
                <a class="HKGroteskSemiBold font-13" (click)="forgotPassword()"
                  onmouseover="this.style.cursor='pointer'">Forgot Password?</a>
              </div>
            </div>
            <div _ngcontent-oiv-c1="" *ngIf="showCookieCheckbox" class="d-flex mt-1 mb-4 terms_policy align-items-start" style="width: 100%">
              <input type="checkbox" name="consent_status" [(ngModel)]="consent_status" (click)="updateConsentStatus(consent_status)" required>
              <span _ngcontent-oiv-c1="" class="label-07">We use cookies on our site, to continue you consent to our use of cookies.
                <!-- By Clicking on “Login”, -->
                 <!-- you agree to Daton -->
                <!-- <a _ngcontent-oiv-c1="" class="HKGroteskBold" href=" https://sarasanalytics.com/terms-of-use/"
                  target="_blank">Terms of service, </a>
                <a _ngcontent-oiv-c1="" class="HKGroteskBold" href="https://sarasanalytics.com/privacy/"
                  target="_blank">Privacy Policy </a>  -->
                   <!-- you consent to our use of cookies. -->
                  </span>
            </div>
            <button mat-flat-button color="orange" class="btn-block btn-lg" style="cursor: pointer" type="submit"
              (click)="signIn()" [disabled]="!signInForm.form.valid">
              <span *ngIf="!under_signIn_process">Log in </span><span *ngIf="!under_signIn_process"
                class="button-right-arrow" style="top: 0.6px;"></span>
              <span class="loading-dots" *ngIf="under_signIn_process">Signing-in</span>
            </button>
          </form>
          <div class="mt-4 text-center">
            <span class="label-07">Don't have a Daton account?
              <a class="HKGroteskBold" (click)="toggleSignIn()" onmouseover="this.style.cursor='pointer'">Create
                one</a></span>
          </div>
        </div>
      </div>
      <div *ngIf="showForgotPassword && showLoginBlock" style="width: 80%;
      padding-left: 12%;" class="mobile-view2">
        <div _ngcontent-oiv-c1="" class="card-body">
          <div *ngIf="!showcheckemail">
            <div _ngcontent-oiv-c1="" class="row justify-content-between align-items-center pd_b">
              <div _ngcontent-oiv-c1="" class="col-auto">
                <span _ngcontent-oiv-c1="" class="daton-logo mb-3"></span>
              </div>
            </div>
            <div class="mb-3">
              <a (click)="goBackToSignIn()" routerLink="/login" class="back-link">
                <span class="material-icons v-align-m">keyboard_backspace</span>
                Back
              </a>
            </div>
            <h3 class="mb-2">Forgot Password</h3>
            <p class="p2 mb-4" style="font-size:0.8rem;">
              Enter your email address and we'll send you an email with
              instructions to reset your password.
            </p>
            <form #forgotPasswordForm="ngForm" *ngIf="showForgotPassword" name="daton-forgot-password-form" class="daton-forgot-password-form">
              <div class="form-group mb-3">

                <mat-form-field style="font-size: 14.2px" appearance="fill">
                  <mat-label>Email address</mat-label>
                  <input matInput type="email" name="email" #email="ngModel" [(ngModel)]="userForgotPassword.email"
                    [maxlength]="49" email required>
                </mat-form-field>
                <div class="touched-error text-error">
                  <div *ngIf="email.touched && !email.valid">
                    Not a valid email.
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <button mat-flat-button color="orange" class="btn-block btn-lg" (click)="submitForgotPassword()"
                  [disabled]="!forgotPasswordForm.form.valid">
                  <span *ngIf="!under_signIn_process">Send Instructions
                  </span>
                  <span *ngIf="!under_signIn_process" class="button-right-arrow" style="top: 1px;"></span>
                  <span class="loading-dots" *ngIf="under_signIn_process">Signing-in</span>
                </button>
              </div>
            </form>
            <div class="mt-4 text-center">
              <span class="label-07">Remember password?
                <a class="HKGroteskBold" onmouseover="this.style.cursor='pointer'"
                  (click)="goBackToSignIn()">Login</a></span>
            </div>
          </div>
          <div *ngIf="showcheckemail">
            <div class="text-center">
              <div class="font-64 text-gray-500 mb-3">
                <img src="../../assets/images/new/email.svg" alt="email" />
              </div>
              <h3 class="mb-2">Check your mail</h3>
              <p class="p2 mb-4">
                We have sent a password recover instructions to your email
              </p>
              <div class="my-3">
                <span class="label-07"><a class="HKGroteskBold" href="">Skip, I'll Confirm later</a></span>
              </div>
              <div class="mt-4">
                <span class="label-07">Did not receive the email? Check your spam filter, or
                  <a class="HKGroteskBold" href="">try again</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #ImgRef_row1>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 383.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 384.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 385.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 386.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 387.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 388.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 389.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 390.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 391.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 392.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 393.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 394.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 395.png" height="70px" />
  </div>
</ng-template>
<ng-template #ImgRef_row2>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 396.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 397.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 398.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 399.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 400.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 401.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 402.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 403.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 404.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 405.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 406.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 407.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 408.png" height="70px" />
  </div>

</ng-template>
<ng-template #ImgRef_row3>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 409.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 410.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 411.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 412.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 413.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 414.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 415.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 416.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 417.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 418.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 419.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 420.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 421.png" height="70px" />
  </div>
  <div class="marquee-item"><img src="../../assets/images/registration/source logos/Group 422.png" height="70px" />
  </div>
</ng-template>

<ng-template #ImgRef_signUp1>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/athletic-greens.png">
  </div>
  <div class="marquee-item-signup"><img
      src="../../assets/images/registration/All Customer Logos/Bare-Performance-Nutrition.png"></div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/bye box experts.png">
  </div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/elevate_brands.png">
  </div>
  <div class="marquee-item-signup" style="margin-left: 8px;margin-right: 20px;"><img
      src="../../assets/images/registration/All Customer Logos/canopy-management.png">
  </div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/Channel-Key.png"></div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/heroes.png" /></div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/murad-logo.png" />
  </div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/oslam.png" /></div>
</ng-template>
<ng-template #ImgRef_signUp2>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/athletic-greens.png">
  </div>
  <div class="marquee-item-signup"><img
      src="../../assets/images/registration/All Customer Logos/Bare-Performance-Nutrition.png"></div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/bye box experts.png">
  </div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/elevate_brands.png">
  </div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/canopy-management.png">
  </div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/Channel-Key.png"></div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/heroes.png" /></div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/murad-logo.png" />
  </div>
  <div class="marquee-item-signup"><img src="../../assets/images/registration/All Customer Logos/oslam.png" /></div>
</ng-template>
